import { Chip } from "@mui/material";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";

interface PhoneChipProps {
  phone?: string;
}

export const PhoneChip = ({ phone }: PhoneChipProps) => {
  if (!phone) {
    return null;
  }

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <a
      href={`tel:${phone}`}
      style={{ textDecoration: "none" }}
      onClick={handleClick}
    >
      <Chip
        icon={<LocalPhoneIcon fontSize="small" />}
        label={phone}
        style={{ padding: 5 }}
      />
    </a>
  );
};
